import clearIsDirty from '../../actions/clearIsDirty';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import MessageListViewState from 'mini-options-store/lib/store/schema/MessageListViewState';
import saveMessageListOption from '../../actions/messageList/saveMessageListOption';
import updateUserOptions from '../../mutators/updateUserOptions';
import { getOptionsStore } from '../../store/Store';
import { orchestrator } from 'satcheljs';
import updateUserConfiguration, {
    UserConfigurationSetting,
} from '../../services/updateUserConfiguration';
import {
    SHOW_SENDER_ON_TOP_IN_LIST_VIEW,
    SHOW_PREVIEW_TEXT_IN_LIST_VIEW,
} from '../../utils/constants';

/**
 * Orchestrator is called when we save message list option.
 * a. It updates the values of showSenderOnTop and showPreviewText locally and on server if changed.
 * b. Sets isDirty to false.
 */
const saveMessageListOptionOrchestrator = orchestrator(saveMessageListOption, async () => {
    const userOptions = getUserConfiguration().UserOptions;
    const store = getOptionsStore();

    const { showSenderOnTop, showPreviewText } = store.activeViewState as MessageListViewState;

    const serviceUpdates: UserConfigurationSetting[] = [];

    if (userOptions.ShowSenderOnTopInListView !== showSenderOnTop) {
        serviceUpdates.push({
            propertyName: SHOW_SENDER_ON_TOP_IN_LIST_VIEW,
            propertyType: 'Boolean',
            propertyValue: `${showSenderOnTop}`,
        });
    }

    if (userOptions.ShowPreviewTextInListView !== showPreviewText) {
        serviceUpdates.push({
            propertyName: SHOW_PREVIEW_TEXT_IN_LIST_VIEW,
            propertyType: 'Boolean',
            propertyValue: `${showPreviewText}`,
        });
    }

    if (serviceUpdates.length) {
        updateUserOptions({
            ShowSenderOnTopInListView: showSenderOnTop,
            ShowPreviewTextInListView: showPreviewText,
        });
        await updateUserConfiguration(serviceUpdates);
    }

    clearIsDirty();
});

export default saveMessageListOptionOrchestrator;
